import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { logoAndroid, logoApple, refresh } from 'ionicons/icons';
import { MomentModule } from 'ngx-moment';
import { UnknownItemViewModel } from 'src/app/models/item.model';
import { SelectStudentEventPayload } from '../../models/event-payloads.model';
import { AnnouncementPublisherComponent } from '../announcement-publisher/announcement-publisher.component';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { DynamicContentComponent } from '../dynamic-content/dynamic-content.component';

@Component({
  selector: 'app-single-unknown-item',
  templateUrl: './single-unknown-item.component.html',
  styleUrls: ['./single-unknown-item.component.scss'],
  imports: [
    DynamicContentComponent,
    AttachmentsComponent,
    AnnouncementPublisherComponent,
    MomentModule,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon
  ]
})
export class SingleUnknownItemComponent {
  @Input() item: UnknownItemViewModel;
  @Output() selectStudent = new EventEmitter<SelectStudentEventPayload>();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
  @Output() toggleItemDone = new EventEmitter<number>();
  @Output() shareItem = new EventEmitter<number>();

  constructor(public platform: Platform) {
    addIcons({ logoApple, logoAndroid, refresh });
  }

  showStudent(event): void {
    event.stopPropagation();

    if (this.item.student) {
      this.selectStudent.emit({
        studentId: this.item.student.id,
        schoolId: this.item.schoolId
      });
    }
  }
}
